var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"id":"project-estimate-tab"}},[_c('v-col',{attrs:{"xl":"12","lg":"12"}},[_c('ProjectEstimates',{attrs:{"project":_vm.project}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }